import { FlowItem, INamedItem, IOwnedItem, ILuidItem } from './resourceParts';

export type FlowDraft =
  INamedItem &
  FlowItem &
  ILuidItem &
  IOwnedItem & {
  readonly createdAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly lastUpdatedAt: string; // YYYY-MM-DDThh:mm:ssZ
}

export enum ContentDraftStatus {
  none = 'NONE',
  unpublished = 'UNPUBLISHED',
  unpublishedchanges = 'UNPUBLISHED_CHANGES',
}